/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 * 
 * IMPORTANT: This library could be replaced with request, axios, or any other http request/response library.  We
 * use the already globally available jquery ajax to not load anymore javascript than is necessary
 */
import {useAuthenticationState} from '../contexts/authentication';

const buildAjaxParams = (path, method, data, onSuccess, onError, onComplete) => {
    const params = {
        url: contextPath + path,
        method: method,
        success: (data) => {
            if (onSuccess) {
                onSuccess(data);
            }
        },
        error: (error) => {
            if (onError) {
                onError(error);
            }
        },
        complete: () => {
            if (onComplete) {
                onComplete();
            }
        }
    };
    if (data) {
        params.data = data;
    }
    return params;
};

const _post = (auth, path, data, onSuccess, onError, onComplete) => {
    if (onSuccess) {
        $.ajax(buildAjaxParams(path, 'POST', data, onSuccess, onError, onComplete));
    } else {
        return $.ajax({url: path, method: 'POST', data, contentType: "application/json"});
    }
};

export const post = (path, data, onSuccess, onError, onComplete) => {
    return _post(null, path, data, onSuccess, onError, onComplete);
};

const _put = (auth, path, data, onSuccess, onError, onComplete) => {
    if (onSuccess) {
        $.ajax(buildAjaxParams(path, 'PUT', data, onSuccess, onError, onComplete));
    } else {
        return $.ajax({url: path, method: 'PUT', data, contentType: "application/json"});
    }
};

export const put = (path, data, onSuccess, onError, onComplete) => {
    return _put(null, path, data, onSuccess, onError, onComplete);
};

const _get = (auth, path, onSuccess, onError, onComplete) => {
    if (onSuccess) {
        $.ajax(buildAjaxParams(path, 'GET', null, onSuccess, onError, onComplete));
    } else {
        return $.ajax({url:path, method: 'GET'});
    }
};

export const get = (path, onSuccess, onError, onComplete) => {
    return _get(null, path, onSuccess, onError, onComplete);
};

const _remove = (auth, path, onSuccess, onError, onComplete) => {
    if (onSuccess) {
        $.ajax(buildAjaxParams(path, 'DELETE', null, onSuccess, onError, onComplete));
    } else {
        return $.ajax({url: path, method: 'DELETE'});
    }
};

export const remove = (path, onSuccess, onError, onComplete) => {
    return _remove(null, path, onSuccess, onError, onComplete);
};

const _fetch = (auth, path) => {
    if (fetch && typeof fetch === 'function') {
        return fetch(contextPath + path, {
            cache: 'default',
            mode: 'same-origin'
        }).then(response => {
            if (response.ok) {
                return response.json();
            } 
                return null;
            
        }).catch(error => {
            return error;
        });
    } 
        return _get(auth, path);
    
};

export const getFetch = (path) => {
    return _fetch(null, path);
};

export const getAll = (...ajaxCalls) => {
    function makeAjaxCallAndStandardiseResponse(call) {
        return $.ajax(call)
            .then(
                // success handler: standardize success params
                (data, statusText, jqXHR) => data, // discard statusText and jqXHR
                // error handler: standardize error params and ensure the error does not remain "caught".
                (jqXHR, textStatus, errorThrown) => $.Deferred().reject(new Error(textStatus || errorThrown)).promise() // discard jqXHR, and deliver Error object on the error path.
    );
    }
    // Aggregate with Promise.all() instead of jQuery.when() to cause a javascript Promise to be returned and results to be delivered as Array.
    return Promise.all(ajaxCalls.map(makeAjaxCallAndStandardiseResponse));
};

export const useRmi = () => {
    const { authToken } = useAuthenticationState();
    const post = (path, data, onSuccess, onError, onComplete) => {
        return _get(authToken, path, onSuccess, onError, onComplete);
    };
    const put = (path, data, onSuccess, onError, onComplete) => {
        return _put(authToken, path, data, onSuccess, onError, onComplete);
    };
    const get = (path, onSuccess, onError, onComplete) => {
        return _get(authToken, path, onSuccess, onError, onComplete);
    };
    const remove = (path, onSuccess, onError, onComplete) => {
        return _remove(authToken, path, onSuccess, onError, onComplete);
    };
    const getFetch = (path, onSuccess, onError, onComplete) => {
        return _fetch(path);
    };
    return {post, put, get, remove, fetch};
};
